import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, IconButton } from '@origo/origo-ui';
import { MagnifyingGlassIcon, XIcon } from '@phosphor-icons/react';
import styles from './PlanSearchBar.module.css';

export interface PlanSearchBarProps {
    value: string;
    onChange: (value: string) => void;
    onClear?: () => void;
    placeholder?: string;
}

// TODO(håvard): denne barren er per nå en ren <TextInput> uten typeahead-
// suggestions eller treff-liste. Drømmeplan har to mønstre vi bør lene oss på:
//   1. AddressSearch fra @origo/origo-components (header) — Kartverket-treff,
//      ferdig dropdown.
//   2. SearchSuggestions i drømmeplan/src/features/drømmeplan/components/ —
//      kommune/eiendom/plan-treff med tastatur-nav, wired mot ArcGIS.
// Filtrering skjer client-side mot useArealplaner-cachen (drømmeplan-admin-
// mønster) — derfor ingen submit eller debounce. Hver tastetrykk oppdaterer
// listen i sanntid.
const PlanSearchBar: React.FC<PlanSearchBarProps> = ({
    value,
    onChange,
    onClear,
    placeholder,
}) => {
    const { t } = useTranslation();

    const handleSubmit = (e: React.FormEvent) => {
        // Preventer default form-submit slik at Enter ikke laster siden på nytt.
        // Filtrering er allerede live via onChange.
        e.preventDefault();
    };

    const showClear = Boolean(value);

    return (
        <form className={styles.form} onSubmit={handleSubmit} role="search" aria-label={t('search.label')}>
            <TextInput
                label={t('search.label')}
                hideLabel
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder ?? t('search.placeholder')}
                prefix={<MagnifyingGlassIcon size={16} aria-hidden />}
                suffix={
                    showClear ? (
                        <IconButton
                            size="sm"
                            variant="ghost"
                            label={t('search.clear')}
                            icon={<XIcon size={14} aria-hidden />}
                            onClick={() => {
                                onChange('');
                                onClear?.();
                            }}
                        />
                    ) : undefined
                }
            />
        </form>
    );
};

export default PlanSearchBar;
